import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Form, Row, Col, Input, Space, Button } from 'antd';
import { SPTableProps } from './types';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import { SPField, FormFrom } from '../../../SPForm';
import { useDeepCompareEffect, useSize } from 'ahooks';
import useSearchCol from './effects/useSearchCol';
import _ from 'lodash';

export interface SearchHandle {
  getFieldsValue: () => any;
}

export default forwardRef<SearchHandle, any>((props, ref) => {
  const {
    columns = [],
    onSearch,
    onReset,
    value,
  } = props;
  const searchRef = useRef(null);
  const size = useSize(searchRef);
  const [form] = Form.useForm();

  const {
    searchColumns,
    isFold,
    setIsFold,
    isShowBtn,
    colSpan,
    btnsSpan,
    formItemLayout,
  } = useSearchCol({
    width: size?.width || 0,
    columns,
  });

  useDeepCompareEffect(() => {
    if (value) {
      form.setFieldsValue(value);
    } else {
      form.resetFields();
    }
  }, [form, value]);

  useImperativeHandle(ref, () => ({
    getFieldsValue: () => form.getFieldsValue(),
  }));

  return (
    <Form form={form} {...formItemLayout} className="lcp-editable-table-search" >
      <Row gutter={32} ref={searchRef}>
        {searchColumns.map((col: any, index: number) => {
          let _fieldProps: any = {};
          if (_.isFunction(col.fieldProps)) {
            _fieldProps = col.fieldProps();
          } else if (_.isObject(col.fieldProps)) {
            _fieldProps = { ...col.fieldProps };
          }
          if (col.searchOptions?.allowClear === false) {
            _fieldProps = { ...col.fieldProps, allowClear: false };
          }
          return (
            <Col span={colSpan} key={index}>
              <SPField
                form={form}
                from={FormFrom.Search}
                label={col.title}
                name={col.dataIndex}
                render={col.renderFormItem}
                valueType={col.valueType}
                formItemProps={col.formItemProps}
                fieldProps={_fieldProps}
                request={col.request}
                requestParams={col.params}
                formValue={value}
                // label不设定宽度，自动向右侧挤压
                labelCol={{}}
                wrapperCol={{ span: 24 }}
                disabled={col.searchOptions?.isDisabled}
              />
            </Col>
          );
        })}
        <Col span={btnsSpan} className="lcp-editable-table-search-btns">
          <Space>
            <Button
              onClick={() => {
                form.resetFields();
                onReset();
              }}
            >
              重置
            </Button>
            <Button
              type="primary"
              onClick={() => {
                // 移除undefined和空的字段
                const v = form.getFieldsValue();
                // const valuesOfNotNull = Object.entries(v).filter((x) => x[1]);
                const valuesOfNotNull = Object.entries(v);
                // 搜索值去除空格
                const valuesOfTrim = valuesOfNotNull.map((p) => {
                  if (typeof (p[1]) === 'string') {
                    return [p[0], p[1].trim()];
                  }
                  return p;
                });
                onSearch && onSearch({ ...value, ...Object.fromEntries(valuesOfTrim) });
              }}
              htmlType="submit"
            >
              查询
            </Button>
            {isShowBtn &&
              <>
                {!isFold ?
                  <a type="link" onClick={() => setIsFold(true)}>
                    展开 <DownOutlined />
                  </a>
                  :
                  <a type="link" onClick={() => setIsFold(false)}>
                    收起 <UpOutlined />
                  </a>
                }
              </>
            }
          </Space>
        </Col>
      </Row>
    </Form>
  );
});
